import server from "@/api/server";

/**
 * @param {Object} data
 * @param {string} [data.firstname]
 * @param {string} [data.surname]
 * @param {string} [data.middlename]
 * @param {string} [data.email]
 * @param {string} [data.bic]
 * @param {string} [data.acc]
 * @param {'osn'| 'usn'} [data.tax_type]
 * @param {'FL'| 'UL'} [data.type]
 * @param {'P' | 'F'} [data.reward_type]
 * @param {string} [data.inn]
 * @param {string} [data.ogrn]
 * @param {string} [data.company_name]
 */
async function update(data) {
  // TODO: переименовать в updateProfile
  let res = await server.post("/agent/agent/profile/update", data);
  return res;
}

async function get() {
  // TODO: переименовать в getProfile
  let res = await server.get("/agent/agent/profile/get");
  return res;
}

/**
 * Добавление загруженного файла к профилю / заявке
 * @param {string} fileid
 * @param {string} name
 * @param {string} oid - id заявки или профиля
 */
async function addFile(fileid, name, oid, package_name) {

  const data = {fileid}
  if (name) {
    data.name = name;
  }
  if (oid) {
    data.oid = oid
  }
  if (package_name) {
    data.name = package_name
  }
  let res = await server.post("agent/agent/file/add", data);
  return res;
}

async function deleteFile(fileid, oid = null) {
  let res = await server.post("agent/agent/file/delete", { fileid, oid });
  return res;
}

async function sendFiles() {
  let res = await server.get("agent/agent/file/send");
  return res;
}

async function updateAgreement() {
  await server.get("agent/agent/profile/update_agreement");
}

export { update, addFile, deleteFile, get, sendFiles, updateAgreement };
